<template>
  <main-layout>
    <v-container>
      <div style="font-size: 23px" class="primary--text mb-3">การบรอดแคสต์</div>
      <div class="mb-3">
        <DateFilter
          ref="datefilter"
          v-model="selectedDate"
          :default-filter="'last_7_days'"
          @changeDate="handleRefetchBroadcast"
        ></DateFilter>
      </div>
      <v-divider />
      <div class="nav nav-tabs my-3" style="overflow-x: auto; white-space: nowrap">
        <v-btn
          small
          depressed
          class="ma-1"
          :outline="filters.broadcast_status != 'all'"
          :color="filters.broadcast_status != 'all' ? 'grey' : 'primary'"
          @click="handleChangeStatus('all')"
          >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
        >
        <v-btn
          small
          depressed
          class="ma-1"
          :outline="filters.broadcast_status != 'broadcasted'"
          :color="filters.broadcast_status != 'broadcasted' ? 'grey' : 'primary'"
          @click="handleChangeStatus('broadcasted')"
          >{{ $t('sent') }} {{ badge['sent'] > 0 ? '(' + badge['sent'] + ')' : '' }}</v-btn
        >
        <v-btn
          small
          depressed
          class="ma-1"
          :outline="filters.broadcast_status != 'schedule'"
          :color="filters.broadcast_status != 'schedule' ? 'grey' : 'primary'"
          @click="handleChangeStatus('schedule')"
          >{{ $t('schedule') }}
          {{ badge['schedule'] > 0 ? '(' + badge['schedule'] + ')' : '' }}</v-btn
        >
        <v-btn
          small
          depressed
          class="ma-1"
          :outline="filters.broadcast_status != 'draft'"
          :color="filters.broadcast_status != 'draft' ? 'grey' : 'primary'"
          @click="handleChangeStatus('draft')"
          >{{ $t('draft') }} {{ badge['draft'] > 0 ? '(' + badge['draft'] + ')' : '' }}</v-btn
        >
      </div>
      <v-divider />
      <div>
        <BroadcastSummary :items="broadcastSummary" />
      </div>
      <v-divider />
      <div class="mt-4">
        <v-layout wrap align-center>
          <v-flex xs6>
            <h5>บรอดแคสต์</h5>
          </v-flex>
          <v-flex xs6>
            <v-layout wrap justify-end align-center>
              <v-btn color="primary" class="ma-0 mb-1" @click="handleExportXlsx">
                <em class="fas fa-file-export mr-1"></em>
                {{ $t('export') }}
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <div class="broadcasts mt-2">
              <a
                href="javascript:void(0);"
                style="text-decoration: none"
                @click="broadcastManageDialogOpen = true"
              >
                <div class="add-broadcast text-xs-center">
                  <em class="fa fa-plus middle" />
                  {{ $t('Add new broadcast') }}
                </div>
              </a>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <BroadcastList
          v-model="broadcastList"
          :total-item="totalItem"
          :page-limit="limit"
          :page-offset="offset"
          @onNextPage="handleChangePage"
          @onCopyBroadcast="handleCopyBroadcast"
          @onDeleteBroadcast="handleDeleteBroadcast"
          @onEditBroadcast="handleEditBroadcast"
        />
      </div>
    </v-container>

    <BroadcastManageDialog
      :form-type="formType"
      :open="broadcastManageDialogOpen"
      :selected-edit-item="selectedEditBroadcast"
      @onClose="
        broadcastManageDialogOpen = false
        selectedEditBroadcast = null
      "
      @onSave="handleSaveBroadcast"
      @onSent="handleRefetchBroadcast"
    />
  </main-layout>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import tcpApi from '@/api/tcp'
import api from '@/api'
import XLSX from 'xlsx'

import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import BroadcastSummary from '@/features/tcp/Broadcast/BroadcastSummary'
import BroadcastList from '@/features/tcp/Broadcast/BroadcastList'
import BroadcastManageDialog from '@/features/tcp/Broadcast/BroadcastManageDialog'

export default {
  components: {
    DateFilter,
    BroadcastSummary,
    BroadcastList,
    BroadcastManageDialog
  },
  data() {
    return {
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      },
      filters: {
        broadcast_status: 'all'
      },
      badge: {
        all: 0,
        sent: 0,
        schedule: 0,
        draft: 0
      },
      broadcastRawData: null,
      broadcastSummary: {
        send_total: 0,
        no_reach_total: 0,
        no_unreach_total: 0
      },
      broadcastList: null,
      formType: 'add',
      selectedEditBroadcast: null,
      broadcastManageDialogOpen: false,
      totalItem: 0,
      limit: 10,
      offset: 0,
      isExport: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    broadcastRawData: {
      deep: true,
      handler() {
        this.handleTransformData()
      }
    }
  },
  mounted() {
    this.handleFetchBroadcast()

    if (this.$store.state.tcpMasterData.memberLevel.length === 0) {
      this.handleGetMemberLevel()
    }
  },
  methods: {
    async handleFetchBroadcast() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getBroadcast()
        if (response && response.status === 200) {
          vm.broadcastRawData = response.data
        }
      } catch (error) {
        console.error(error)
        return
      } finally {
        vm.$store.commit('CLEAR_LOADING')
      }
    },
    async getBroadcast() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.totalItem : vm.limit
        const offset = vm.isExport ? 0 : vm.offset

        const params = {
          page_id: vm.selectedBot.pageid,
          datefrom: dayjs(vm.selectedDate.start).format('YYYY-MM-DD'),
          dateto: dayjs(vm.selectedDate.end).format('YYYY-MM-DD'),
          limit,
          offset,
          ...(vm.filters.broadcast_status !== 'all'
            ? {
                status: vm.filters.broadcast_status
              }
            : {})
        }

        const response = await await tcpApi.getBroadcast({ params })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleTransformData() {
      const vm = this
      try {
        if (vm.broadcastRawData) {
          vm.broadcastSummary = {
            send_total: vm.broadcastRawData.send_total,
            no_reach_total: vm.broadcastRawData.no_reach_total,
            no_unreach_total: vm.broadcastRawData.no_unreach_total
          }

          vm.broadcastList = vm.broadcastRawData.data || []
          vm.totalItem = parseInt(vm.broadcastRawData.total) || 0

          const countByStatus = vm.broadcastList.reduce(
            (prev, cur) => ({
              ...prev,
              [cur.status]: (prev[cur.status] || 0) + 1
            }),
            {}
          )

          this.badge = {
            ...this.badge,
            all: vm.totalItem,
            ...countByStatus
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleSaveBroadcast(payload) {
      const vm = this
      try {
        vm.saveBroadcast(payload.data, function (status, id) {
          payload.onSave(status, id)

          if (status) {
            vm.broadcastManageDialogOpen = false
            vm.handleFetchBroadcast()
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    handleCopyBroadcast(data) {
      const vm = this
      try {
        if (data) {
          vm.saveBroadcast(data, function (status, id) {
            if (status && id) {
              vm.$swal.fire({
                title: vm.$t('Broadcast {copy_name} copy', {
                  // eslint-disable-next-line no-useless-escape
                  copy_name: data.name.replace(/\<|\>/g, '')
                }),
                type: 'success',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })

              vm.handleFetchBroadcast()
            }
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleEditBroadcast(broadcast) {
      this.selectedEditBroadcast = broadcast
      this.formType = 'edit'
      this.broadcastManageDialogOpen = true
    },
    saveBroadcast: function (data, callback) {
      try {
        api.updateBroadcast(data, function (error, response) {
          if (error) {
            console.error(error)
            callback(false, null)
            return
          }
          let id = null
          if (response.broadcastid) {
            id = response.broadcastid
          }
          callback(true, id)
        })
      } catch (error) {
        console.error(error)
      }
    },
    handleDeleteBroadcast(broadcastId) {
      const vm = this

      try {
        api.deleteBroadcast(
          {
            pageid: vm.selectedBot.pageid,
            broadcastid: broadcastId
          },
          function (error, response) {
            if (error) {
              console.error(error)
              return
            }

            if (response) {
              vm.handleFetchBroadcast()
            }
          }
        )
      } catch (error) {
        console.error(error)
      }
    },
    async handleGetMemberLevel() {
      const vm = this
      try {
        const page_id = vm.selectedBot.pageid
        const response = await tcpApi.getMemberLevel({
          params: {
            page_id
          }
        })
        if (response && response.status === 200) {
          vm.$store.state.tcpMasterData.memberLevel = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    handleChangePage(offset) {
      this.offset = offset
      this.handleFetchBroadcast()
    },
    handleRefetchBroadcast() {
      this.offset = 0
      this.handleFetchBroadcast()
    },
    handleChangeStatus(status) {
      this.filters.broadcast_status = status
      this.handleRefetchBroadcast()
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        vm.isExport = true
        const response = await vm.getBroadcast()
        const data = response.data.data
        vm.isExport = false

        if (data == null) return

        let json = []
        json.push([
          `${vm.$t('from')} ` +
            dayjs(vm.selectedDate.start).format('DD/MM/YYYY') +
            ` ${vm.$t('to')} ` +
            dayjs(vm.selectedDate.end).format('DD/MM/YYYY')
        ])
        json.push([vm.$t('All')])
        json.push([
          'ชื่อบรอดแคสต์',
          'วันที่สร้าง',
          'วันที่ส่ง',
          'สถานะ',
          'ช่องทาง',
          'แอดมินผู้ส่ง',
          'จำนวนผู้ใช้ที่ได้รับ',
          'จำนวนผู้ใช้ที่ไม่ได้รับ'
        ])

        data.map((el) => {
          json.push([
            el.name,
            dayjs(el.createdtime).format('DD/MM/YYYY HH:mm'),
            el.senttime ? dayjs(el.senttime).format('DD/MM/YYYY HH:mm') : '-',
            vm.$t(el.status),
            'Line',
            el.createdby,
            el.no_reach,
            el.no_unreach
          ])
        })

        const header = [['', '', '', '', '', '', '', '']]
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, header)
        XLSX.utils.sheet_add_json(ws, json, { origin: 'A1', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)

        XLSX.writeFile(wb, `broadcast-list.xlsx`)
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.commit('CLEAR_LOADING')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/tcp/Broadcast.vue